module.exports = __webpack_public_path__ + "static/media/dinnings_thumb_even.bc611a3c.jpg";